(function () {
  'use strict';
  if (window.__hilfeCenter) return;
  window.__hilfeCenter = true;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }
  var T = {};
  try { T = JSON.parse((document.querySelector('[data-hilfe-texte]') || {}).textContent || '{}'); } catch (e) {}
  function t(k) { return T[k] || ''; }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  var cache = {};
  function anleitungen(q) {
    q = q.trim();
    if (q.length < 2) return Promise.resolve([]);
    if (cache[q]) return cache[q];
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search?q=' + encodeURIComponent(q)
      + '&type=product&options%5Bprefix%5D=last&section_id=anleitung-treffer';
    cache[q] = fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var m = /<script type="application\/json" data-anleitung-treffer>([\s\S]*?)<\/script>/.exec(html);
      try { return m ? JSON.parse(m[1]) : []; } catch (e) { return []; }
    }).catch(function () { return []; });
    return cache[q];
  }
  function trefferHtml(liste, wa, nurMitLink, max) {
    return liste.filter(function (a) { return !nurMitLink || a.l; }).slice(0, max || 6).map(function (a) {
      var ziel = a.l || (wa ? wa + (wa.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(t('wa_text') + ' ' + a.t) : a.u);
      var wort = a.l ? (a.pdf ? t('pdf') : t('seite')) : (wa ? t('anfordern') : t('produkt'));
      return '<a href="' + esc(ziel) + '" target="_blank" rel="noopener">' + (a.i ? '<img src="' + esc(a.i) + '" alt="">' : '')
        + '<span>' + esc(a.t) + '</span><span class="z">' + wort + '</span></a>';
    }).join('');
  }

  function ebene(leiste, eingabe, liste, zu, titel) {
    if (!window.Suchebene || !leiste || !eingabe || !liste) return;
    window.Suchebene.binden({ leiste: leiste, eingabe: eingabe, liste: liste, zu: zu || function () {}, titel: titel || '' });
  }
  function nachmessen() { if (window.Suchebene && window.Suchebene.messen) { try { window.Suchebene.messen(); } catch (e) {} } }
  if (window.matchMedia && window.matchMedia('(max-width: 1023px)').matches) {
    document.querySelectorAll('[data-hsu-input][data-kurz], [data-anl-input][data-kurz]').forEach(function (f) {
      if (f.getAttribute('data-kurz')) f.placeholder = f.getAttribute('data-kurz');
    });
  }

  document.querySelectorAll('[data-hsu]').forEach(function (box) {
    var input = box.querySelector('[data-hsu-input]'), erg = box.querySelector('[data-hsu-erg]');
    var wa = box.getAttribute('data-wa') || '';
    var fragen = function () { return Array.prototype.slice.call(document.querySelectorAll('details.fqb__eintrag, .fkt details')); };
    var uhr = null, letzte = '';

    var QUELLEN = (box.getAttribute('data-quellen') || '').split('|').filter(Boolean);
    var SPEICHER = 'hilfe_fragen_v3';
    var fremde = null, fremdLaden = null;
    try {
      var alt = JSON.parse(localStorage.getItem(SPEICHER) || 'null');
      if (alt && alt.quellen === QUELLEN.join('|')) fremde = alt.liste;
    } catch (e) {}
    function kennung(x) { return window.FrageSprung ? window.FrageSprung.kennung(x) : norm(x).replace(/[^a-z0-9]+/g, '-'); }
    function fremdeHolen() {
      if (!fremdLaden) fremdLaden = frischLaden();
      return fremde ? Promise.resolve(fremde) : fremdLaden;
    }
    function frischLaden() {
      if (!QUELLEN.length || !window.FrageSprung || !window.DOMParser) { fremde = fremde || []; return Promise.resolve(fremde); }
      return Promise.all(QUELLEN.map(function (url) {
        return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var titel = (doc.title || '').split(/\s[–|-]\s/)[0];
          var seite = url.indexOf('/pages/') === 0 ? titel : ((doc.querySelector('h1') || {}).textContent || titel);
          return window.FrageSprung.sammeln(doc).map(function (e) {
            return { f: e.frage, a: e.antwort.slice(0, 400), url: url.split('#')[0], seite: String(seite || '').replace(/\s+/g, ' ').trim() };
          });
        }).catch(function () { return []; });
      })).then(function (teile) {
        var gesehen = {};
        fragen().forEach(function (d) { gesehen[kennung(d.querySelector('summary').textContent)] = true; });
        fremde = [];
        teile.forEach(function (liste) {
          liste.forEach(function (e) { var k = kennung(e.f); if (gesehen[k]) return; gesehen[k] = true; fremde.push(e); });
        });
        try { localStorage.setItem(SPEICHER, JSON.stringify({ zeit: Date.now(), quellen: QUELLEN.join('|'), liste: fremde })); } catch (e) {}
        if (input.value.trim().length >= 2) zeige(input.value);
        return fremde;
      });
    }
    input.addEventListener('focus', function () { fremdeHolen(); }, { once: true });

    function zeige(q) {
      var qn = norm(q);
      if (qn.length < 2) { erg.hidden = true; return; }
      var worte = qn.split(/\s+/);
      function passt(text) { var tn = norm(text); return worte.every(function (w) { return tn.indexOf(w) > -1; }); }
      var fr = fragen().filter(function (d) { return passt(d.textContent); }).slice(0, 5);
      Promise.all([anleitungen(q), fremdeHolen()]).then(function (beides) {
        var an = beides[0];
        if (q !== letzte) return;
        var weitere = (beides[1] || []).filter(function (e) { return passt(e.f + ' ' + e.a); }).slice(0, Math.max(0, 6 - fr.length));
        var html = '';
        if (fr.length || weitere.length) html += '<div class="hsu__k">' + esc(t('antworten')) + '</div>';
        if (fr.length) html += fr.map(function (d) {
          return '<a href="#" data-hsu-frage="' + fragen().indexOf(d) + '">' + esc(d.querySelector('summary').textContent.replace(/\s+/g, ' ').trim()) + '</a>';
        }).join('');
        if (weitere.length) html += weitere.map(function (e) {
          return '<a href="' + esc(e.url + '#frage-' + kennung(e.f)) + '"><span>' + esc(e.f) + '</span>'
            + (e.seite ? '<span class="hsu__seite">' + esc(e.seite) + '</span>' : '') + '</a>';
        }).join('');
        var ah = q.trim().length >= 3 ? trefferHtml(an, wa, true, 3) : '';
        if (ah) html += '<div class="hsu__k">' + esc(t('anleitungen')) + '</div>' + ah;
        erg.innerHTML = html || '<div class="hsu__leer">' + esc(t('nichts')) + '</div>';
        erg.hidden = false;
        nachmessen();
      });
    }
    input.addEventListener('input', function () { letzte = input.value; clearTimeout(uhr); var q = input.value; uhr = setTimeout(function () { zeige(q); }, 200); });
    box.querySelectorAll('[data-hsu-beliebt] > a').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); input.value = b.textContent.trim(); letzte = input.value; zeige(input.value); input.focus(); });
    });
    erg.addEventListener('click', function (e) {
      var a = e.target.closest('[data-hsu-frage]');
      if (!a) return;
      e.preventDefault();
      var d = fragen()[+a.getAttribute('data-hsu-frage')];
      if (!d) return;
      d.open = true; d.classList.add('is-treffer');
      d.scrollIntoView({ behavior: 'smooth', block: 'center' });
      erg.hidden = true;
      setTimeout(function () { d.classList.remove('is-treffer'); }, 1800);
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) erg.hidden = true; });
    ebene(box.querySelector('.hsu__feld'), input, erg, function () { erg.hidden = true; }, t('suche_titel'));
  });

  function zurSuche(id, weich) {
    var ziel = id && document.getElementById(id);
    var feld = ziel && ziel.querySelector('[data-anl-input]');
    if (!feld) return false;
    ziel.scrollIntoView({ behavior: weich ? 'smooth' : 'auto', block: 'start' });
    setTimeout(function () { feld.focus({ preventScroll: true }); }, weich ? 450 : 0);
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || a.pathname !== location.pathname) return;
    var id = decodeURIComponent(a.hash.slice(1));
    if (zurSuche(id, true)) { e.preventDefault(); history.replaceState(null, '', '#' + id); }
  });
  if (location.hash) zurSuche(decodeURIComponent(location.hash.slice(1)), false);

  document.querySelectorAll('[data-anl]').forEach(function (box) {
    var input = box.querySelector('[data-anl-input]'), liste = box.querySelector('[data-anl-liste]');
    var wa = box.getAttribute('data-wa') || '', start = liste.innerHTML, uhr = null, letzte = '';
    input.addEventListener('input', function () {
      var q = input.value; letzte = q; clearTimeout(uhr);
      if (q.trim().length < 2) { liste.innerHTML = start; return; }
      uhr = setTimeout(function () {
        anleitungen(q).then(function (an) {
          if (q !== letzte) return;
          liste.innerHTML = trefferHtml(an, wa, false) || '<p class="leer">' + esc(t('kein_produkt')) + '</p>';
          nachmessen();
        });
      }, 200);
    });
    ebene(box.querySelector('.anl__feld'), input, liste, null, t('anleitung_titel'));
  });
})();
